/* eslint-disable-next-line import/prefer-default-export */
export const NOTIFICATION_TYPES = {
  awssns: 'AWS SNS',
  email: 'Email',
  grafana: 'Grafana',
  irc: 'IRC',
  mattermost: 'Mattermost',
  pagerduty: 'Pagerduty',
  rocketchat: 'Rocket.Chat',
  slack: 'Slack',
  twilio: 'Twilio',
  webhook: 'Webhook',
};
